import React from "react";
import "../styles.css";

function Footer() {
  return (
    <footer className="footer">General Goodies. Made by Eivind Johnsen</footer>
  );
}

export default Footer;
